const GoldIcon = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{flexShrink: 0}}
    >
      <g clip-path="url(#clip0_13967_18589)">
        <path
          d="M7.72904 9.95167C7.90032 9.42914 7.98595 9.16788 8.16087 8.98819C8.24397 8.90282 8.34046 8.83209 8.44638 8.77892C8.66933 8.66699 8.94014 8.66699 9.48176 8.66699C10.0234 8.66699 10.2942 8.66699 10.5171 8.77892C10.6231 8.83209 10.7195 8.90282 10.8027 8.98819C10.9776 9.16788 11.0632 9.42914 11.2345 9.95167L11.4113 10.4911C11.6246 11.1418 11.7312 11.4671 11.5718 11.692C11.4123 11.917 11.0751 11.917 10.4007 11.917H8.56286C7.88841 11.917 7.55118 11.917 7.39174 11.692C7.23231 11.4671 7.33895 11.1418 7.55223 10.4911L7.72904 9.95167Z"
          stroke="white"
          stroke-width="0.8125"
        />
        <path
          d="M4.74988 5.61829C4.92116 5.09577 5.0068 4.8345 5.18171 4.65481C5.26482 4.56944 5.3613 4.49872 5.46723 4.44554C5.69017 4.33362 5.96098 4.33362 6.5026 4.33362C7.04423 4.33362 7.31504 4.33362 7.53798 4.44554C7.6439 4.49872 7.74039 4.56944 7.82349 4.65481C7.99841 4.8345 8.08405 5.09577 8.25532 5.61829L8.43213 6.1577C8.64542 6.80838 8.75206 7.13372 8.59262 7.35867C8.43319 7.58362 8.09596 7.58362 7.4215 7.58362H5.58371C4.90925 7.58362 4.57202 7.58362 4.41259 7.35867C4.25315 7.13372 4.35979 6.80838 4.57307 6.1577L4.74988 5.61829Z"
          stroke="white"
          stroke-width="0.8125"
        />
        <path
          d="M1.77071 9.95167C1.94199 9.42914 2.02763 9.16788 2.20254 8.98819C2.28565 8.90282 2.38213 8.83209 2.48806 8.77892C2.711 8.66699 2.98181 8.66699 3.52343 8.66699C4.06505 8.66699 4.33587 8.66699 4.55881 8.77892C4.66473 8.83209 4.76122 8.90282 4.84432 8.98819C5.01924 9.16788 5.10488 9.42914 5.27615 9.95167L5.45296 10.4911C5.66625 11.1418 5.77289 11.4671 5.61345 11.692C5.45402 11.917 5.11679 11.917 4.44233 11.917H2.60453C1.93008 11.917 1.59285 11.917 1.43341 11.692C1.27398 11.4671 1.38062 11.1418 1.5939 10.4911L1.77071 9.95167Z"
          stroke="white"
          stroke-width="0.8125"
        />
        <path
          d="M6.50259 1.08362V2.16695M4.06509 1.89612L4.87759 2.70862M8.94009 1.89612L8.12759 2.70862"
          stroke="white"
          stroke-width="0.8125"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_13967_18589">
          <rect width="13" height="13" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GoldIcon;
